import React from "react";

const Content = () => {
    return (
        <>
            <main id="body-content">
                <section className="wide-tb-80">
                    <div className="container pos-rel">
                        <div className="row align-items-start">
                            <div className="col-md-12 col-lg-8 blog-list">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="blog-warp">
                                            <img src="images/blog_img_1.jpg" alt="" className="rounded" />
                                            <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                            <h4 className="h4-md mb-3"><a href="blogsingle">Liberalisation in 2017 year of cargo</a></h4>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="blog-warp">
                                            <img src="images/blog_img_2.jpg" alt="" className="rounded" />
                                            <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                            <h4 className="h4-md mb-3"><a href="blogsingle">Fleet Management Comes into Focus</a></h4>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="blog-warp">
                                            <img src="images/blog_img_4.jpg" alt="" className="rounded" />
                                            <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                            <h4 className="h4-md mb-3"><a href="blogsingle">New Warehouse Now Operational</a></h4>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="blog-warp">
                                            <img src="images/blog_img_5.jpg" alt="" className="rounded" />
                                            <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                            <h4 className="h4-md mb-3"><a href="blogsingle">Project Logistics: Going the Distance</a></h4>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="blog-warp">
                                            <img src="images/blog_img_6.jpg" alt="" className="rounded" />
                                            <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                            <h4 className="h4-md mb-3"><a href="blogsingle">For European sustainable development week</a></h4>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="blog-warp">
                                            <img src="images/blog_img_7.jpg" alt="" className="rounded" />
                                            <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                            <h4 className="h4-md mb-3"><a href="blogsingle">Logistics Should Brace for Changes in Air Cargo</a></h4>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="blog-warp">
                                            <img src="images/blog_img_8.jpg" alt="" className="rounded" />
                                            <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                            <h4 className="h4-md mb-3"><a href="blogsingle">Distinctively promote real-time strategic warehouses areas</a></h4>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="blog-warp">
                                            <img src="images/blog_img_9.jpg" alt="" className="rounded" />
                                            <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                            <h4 className="h4-md mb-3"><a href="blogsingle">Project Logistics: Going the Distance</a></h4>
                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <a href="#" className="btn-theme bg-primary">Older Post <i className="icofont-rounded-right"></i></a>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-4">
                                <aside className="sidebar-spacer row">
                                    <div className="sidebar-primary col-lg-12 col-md-6">
                                        <div className="widget-wrap">
                                            <h3 className="h3-md fw-7 mb-4">Search</h3>
                                            <form className="flex-nowrap col ml-auto footer-subscribe p-0">
                                                <input type="text" className="form-control" placeholder="Search …" />
                                                <button type="submit" className="btn btn-theme bg-secondary"><i className="icofont-search p-0"></i></button>
                                            </form>
                                        </div>
                                        <div className="widget-wrap">
                                            <h3 className="h3-md fw-7 mb-4">Recent Posts</h3>
                                            <div className="blog-list-footer">
                                                <ul className="list-unstyled">
                                                    <li>
                                                        <div className="media">
                                                            <div className="post-thumb">
                                                                <img src="images/post_thumb_1.jpg" alt="" className="rounded-circle" />
                                                            </div>
                                                            <div className="media-body post-text">
                                                                <h5 className="mb-3 h5-md"><a href="#">Liberalisation of air cargo</a></h5>
                                                                <p>Far far away, behind the word mountains, far from the countries.</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="media">
                                                            <div className="post-thumb">
                                                                <img src="images/post_thumb_2.jpg" alt="" className="rounded-circle" />
                                                            </div>
                                                            <div className="media-body post-text">
                                                                <h5 className="mb-3 h5-md"><a href="#">New Ocean Freight Rules</a></h5>
                                                                <p>Far far away, behind the word mountains, far from the countries.</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="widget-wrap text-center bg-sky-blue rounded py-5">
                                            <div className="mb-2"><i className="icofont-headphone-alt icofont-4x"></i></div>
                                            <h3 className="h3-md fw-5 txt-orange mb-4">Need help?</h3>
                                            <p>Call our award-winning<br /> support team 24/7</p>
                                            <a href="#" className="btn-theme bg-secondary mt-3">Get In Touch <i className="icofont-rounded-right"></i></a>
                                        </div>
                                    </div>
                                    <div className="sidebar-secondary col-lg-12 col-md-6">
                                        <div className="widget-wrap">
                                            <h3 className="h3-md fw-7 mb-4">Recent Posts</h3>
                                            <div className="blog-list-categories">
                                                <ul className="list-unstyled">
                                                    <li className="active"><a href=" href"> Business</a></li>
                                                    <li><a href="#">Logistics</a></li>
                                                    <li><a href="#">News</a></li>
                                                    <li><a href="#">Recent</a></li>
                                                    <li><a href="#">Transport</a></li>
                                                    <li><a href="#">Warehousing</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="widget-wrap">
                                            <h3 className="h3-md fw-7 mb-4">Our Photostream</h3>
                                            <ul id="basicuse" className="photo-thumbs"></ul>
                                        </div>
                                        <div className="widget-wrap">
                                            <h3 className="h3-md fw-7 mb-4">Text Widget</h3>
                                            <p>Explain to you how all this mistaken idea of hovered link and praising pain was born and I will give you a complete count of the system expound</p>
                                        </div>
                                    </div>
                                </aside>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};
export default Content;
